import {ReactNode} from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs} from "@pg-design/helpers-css";

interface IProps {
    children: ReactNode;
    className?: string;
}
export function HeaderCta(props: IProps) {
    const {children, className} = props;

    return (
        <div css={headerCta} className={className}>
            {children}
        </div>
    );
}

const headerCta = css`
    display: flex;
    align-items: center;
    gap: ${crs(2)};
`;
import {ReactNode} from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs} from "@pg-design/helpers-css";

interface IProps {
    children: ReactNode;
    className?: string;
}
export function HeaderCta(props: IProps) {
    const {children, className} = props;

    return (
        <div css={headerCta} className={className}>
            {children}
        </div>
    );
}

const headerCta = css`
    display: flex;
    align-items: center;
    gap: ${crs(2)};
`;
